module.exports = __webpack_public_path__ + "static/img/james_2.e193750f.jpg";